import systemRouter from './payables';
import currencyRouter from './generalAccounting';
import payment from './payment';
import saleInvoice from './saleInvoice';
import transactionType from './transactionType';
import bankAccount from './bankAccount';
import withholding from './withholding'; //预提管理
import bankDirectFlow from './bankDirectFlow'; //银企直连
import transfer from './transfer'; //转款单
import accountingEngine from './accountingEngine'; //会计引擎
import bizBankCfg from './bizBankCfg'; // 业务与银行账户配置

export default {
  systemRouter,
  currencyRouter,
  payment,
  saleInvoice,
  transactionType,
  bankAccount,
  withholding,
  bankDirectFlow,
  transfer,
  accountingEngine,
  bizBankCfg,
};
